export const copy = {
  hero: {
    h1: {
      before: 'Объясню математику так, чтобы ',
      accent: 'наконец стало понятно',
    },
    subtitle:
      'От тройки к пятёрке, от ОГЭ к ЕГЭ. 17 лет опыта, 100+ учеников. Программа под ребёнка — без давления и страха.',
    ctaPrimary: 'Записаться на пробное',
    ctaSecondary: 'Посмотреть кейсы ↓',
    subline: 'Онлайн · интерактивная доска + видеосвязь · Екатеринбург',
    photoAlt: 'Мария Брызгалова — репетитор по математике',
    photoCaption: 'Мария Брызгалова · репетитор по математике, Екатеринбург',
    stats: [
      { value: '17', label: 'лет преподаю' },
      { value: '100+', label: 'учеников за годы работы' },
      { value: '2020', label: 'онлайн с' },
    ],
  },
  pain: {
    title: 'Вам знакомо?',
    items: [
      { title: 'Тройка в четверти, экзамен через год', who: 'родитель' },
      { title: 'Учитель объясняет — не понимаю', who: 'ученик' },
      { title: 'Школа не тянет до 80+ баллов', who: 'амбиция' },
    ],
    closing: 'Начнём с того, где реально пробел, и пойдём шаг за шагом.',
  },
  formats: {
    title: 'Форматы занятий',
    items: [
      {
        name: 'Индивидуально',
        price: '1500–3000 ₽ / 60 мин',
        frequency: '2 раза в неделю',
        bullets: [
          'Программа под ученика',
          'Разбор ДЗ и ошибок',
          'Подготовка к ОГЭ/ЕГЭ или подтянуть с нуля',
        ],
        cta: 'Записаться на пробное',
      },
      {
        name: 'Мини-группа',
        price: '7000 ₽ / мес',
        frequency: '1 раз в неделю, до 3 человек',
        bullets: [
          'Ученики одного уровня',
          'Разбор типовых заданий',
          'Дешевле индивидуальных',
        ],
        cta: 'Записаться на пробное',
      },
      {
        name: 'Летний интенсив',
        price: 'с 15 августа',
        frequency: 'программа опережения',
        bullets: [
          'Старт нового года с запасом',
          'Повторение базы перед новыми темами',
          'Летом спокойнее, меньше стресса',
        ],
        cta: 'Записаться на пробное',
      },
    ],
  },
  method: {
    title: 'Как я работаю',
    steps: [
      {
        n: 1,
        title: 'Диагностика на пробном',
        body: 'Смотрю реальный уровень, слушаю запрос, договариваемся о формате.',
      },
      {
        n: 2,
        title: 'Программа под ученика',
        body: 'Не «от корки до корки учебника» — от слабого места к сильному.',
      },
      {
        n: 3,
        title: 'Опережение школы',
        body: 'Идём на шаг впереди школьной программы, чтобы в классе было легко.',
      },
      {
        n: 4,
        title: 'Домашка с разбором',
        body: 'Каждая ошибка — в конспект. Через месяц — тот же тип заданий решается сам.',
      },
    ],
    marginalia: 'Для каждого ученика я составляю свою программу — это не маркетинг, это реально так.',
    marginaliaSecondary:
      'Мне важно, чтобы ученик увидел: задача решается шаг за шагом. Как только это случается, страх уходит.',
  },
  howItWorks: {
    title: 'Как проходит занятие',
    body: 'Интерактивная доска, видеосвязь, конспекты сохраняются. Ребёнок может вернуться к разбору в любой момент.',
    screenshotAlt: 'Интерактивная доска matemasha.ru во время занятия',
    linkText: 'Посмотреть пример доски →',
  },
  cases: {
    title: 'Результаты учеников',
    items: [
      {
        headline: 'С тройки на пятёрку за полгода',
        detail: '8 класс, подтягивали геометрию с нуля.',
        tags: ['8 класс', 'геометрия'],
      },
      {
        headline: 'Поступила в лицей 1535',
        detail: '9 класс, подготовка к профильному лицею, экзамен с первого раза.',
        tags: ['9 класс', 'лицей 1535'],
      },
      {
        headline: '84 балла ЕГЭ профиль',
        detail: '11 класс, 2024. Цель была 70 — результат выше плана.',
        tags: ['11 класс', 'ЕГЭ профиль'],
      },
      {
        headline: 'Пересдали ОГЭ летом',
        detail: 'Группа из 3 человек, все прошли минимальный порог.',
        tags: ['9 класс', 'ОГЭ'],
      },
    ],
    reviewsCaption: 'Благодарю ребят и родителей, что разрешили поделиться.',
  },
  ctaStrip: {
    title: 'Пора начать. Первые 20 минут — бесплатно.',
    subtitle: 'Покажу программу под вашего ребёнка. Без обязательств — поговорим, посмотрим, что нужно.',
    cta: 'Записаться на пробное',
  },
  about: {
    title: 'Обо мне',
    body: [
      'Я Мария, репетитор по математике с 2007 года.',
      'За 17 лет работы я видела сотни учеников: отличников, которым нужен вызов, и ребят, которые боятся открыть учебник. С каждым мы находили свой путь.',
      'Онлайн работаю с 2020 года — и уверена, что дистанционный формат может быть таким же тёплым и результативным, как офлайн.',
    ],
    mironCaption: 'Это Мирон. Он презирает тех, кто не уделяет 10 минут в день подготовке.',
  },
  faq: {
    title: 'Частые вопросы',
    items: [
      {
        q: 'Сколько стоит пробное занятие?',
        a: 'Первые 20 минут — бесплатно, знакомимся и обсуждаем запрос. Если подходим друг другу, договариваемся о регулярных занятиях.',
      },
      {
        q: 'Как оплачивать?',
        a: 'Переводом на карту раз в неделю или вперёд за месяц — как вам удобнее. Чек присылаю.',
      },
      {
        q: 'С какого класса работаете?',
        a: 'С 7 по 11 класс. Основной фокус — подготовка к ОГЭ и ЕГЭ, но беру и на подтягивание с более раннего уровня.',
      },
      {
        q: 'Что если ребёнок стесняется?',
        a: 'Это нормально. Первое занятие — без давления. Я не прошу «показать, что умеете» — просто говорим.',
      },
      {
        q: 'Можно ли заниматься в праздники?',
        a: 'Обычно на новогодние и майские берём паузу. В остальные дни — по договорённости.',
      },
      {
        q: 'Что если пропустили занятие?',
        a: 'Предупредите за 4 часа — перенесём без оплаты. Позже — занятие считается проведённым.',
      },
      {
        q: 'Нужно ли покупать учебники?',
        a: 'Нет. Все материалы я присылаю сама — задачники, конспекты, подборки из ФИПИ.',
      },
      {
        q: 'Как подключиться технически?',
        a: 'Нужен компьютер с интернетом и наушниками. В день занятия приходит ссылка — заходите одним кликом.',
      },
    ],
  },
  contact: {
    title: 'Запишемся на пробное — поговорим, посмотрим, что нужно',
    subtitle: 'Отвечу в течение суток.',
    fields: {
      name: 'Ваше имя',
      contact: 'Телефон, Telegram или email',
      grade: 'Класс ученика',
    },
    consent:
      'Отправляя форму, вы соглашаетесь с обработкой персональных данных согласно',
    consentLink: 'политике',
    consentHref: '/privacy',
    submit: 'Отправить',
    alt: {
      telegram: { label: 'Telegram', href: 'https://t.me/repetitor_mariya' },
      vk: { label: 'ВКонтакте', href: 'https://vk.com/repetitor_mariya' },
      email: { label: 'Email', href: 'mailto:hello@matemasha.ru' },
    },
    successTitle: 'Спасибо!',
    successBody: 'Заявка получена. Я свяжусь с вами в течение суток.',
    errorGeneric: 'Что-то пошло не так. Попробуйте ещё раз или напишите в Telegram.',
  },
} as const;
